module.exports = __webpack_public_path__ + "static/6305-woodrose-17-6be058e427a4d5866690e3ae46a7f6d6.jpg";